export default __webpack_public_path__ + "static/media/blur.9e839a65.png";